/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { TruckMenuContentFragment } from './TruckMenuContentFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type TruckMenusQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type TruckMenusQuery = {
  __typename: 'Query'
  truck: {
    __typename: 'Truck'
    id: number
    name: string
    scheduleUrl: string
    primaryUpsellTypes: Array<{
      __typename: 'UpsellType'
      id: number
      name: string
    }>
    defaultEventMenu: {
      __typename: 'Menu'
      public: boolean
      id: number
      active: boolean
      catering: boolean
      hasPrices: boolean
      taxIncluded: boolean
      items: Array<{
        __typename: 'Item'
        id: number
        name: string
        description: string | null
        image: { __typename: 'ItemImage'; medium: string; present: boolean }
        upsellType: { __typename: 'UpsellType'; id: number }
        price: { __typename: 'Money'; formatted: string; cents: number }
        tags: Array<{ __typename: 'ItemTag'; id: string; name: string }>
      }>
    } | null
    defaultCateringMenu: {
      __typename: 'Menu'
      public: boolean
      id: number
      active: boolean
      catering: boolean
      hasPrices: boolean
      taxIncluded: boolean
      items: Array<{
        __typename: 'Item'
        id: number
        name: string
        description: string | null
        image: { __typename: 'ItemImage'; medium: string; present: boolean }
        upsellType: { __typename: 'UpsellType'; id: number }
        price: { __typename: 'Money'; formatted: string; cents: number }
        tags: Array<{ __typename: 'ItemTag'; id: string; name: string }>
      }>
    } | null
  }
  upsellTypes: Array<{ __typename: 'UpsellType'; id: number; name: string }>
}

export const TruckMenusQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'truckMenusQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'truck' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryUpsellTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultEventMenu' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'public' }
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TruckMenuContentFragment'
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultCateringMenu' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'public' }
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TruckMenuContentFragment'
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsellTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    },
    ...TruckMenuContentFragment.definitions
  ]
} as unknown as DocumentNode

/**
 * __useTruckMenusQuery__
 *
 * To run a query within a React component, call `useTruckMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTruckMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTruckMenusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTruckMenusQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TruckMenusQuery,
    TruckMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TruckMenusQuery, TruckMenusQueryVariables>(
    TruckMenusQueryDocument,
    options
  )
}
export function useTruckMenusQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TruckMenusQuery,
    TruckMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TruckMenusQuery,
    TruckMenusQueryVariables
  >(TruckMenusQueryDocument, options)
}
export type TruckMenusQueryHookResult = ReturnType<typeof useTruckMenusQuery>
export type TruckMenusQueryLazyQueryHookResult = ReturnType<
  typeof useTruckMenusQueryLazyQuery
>
export type TruckMenusQueryQueryResult = Apollo.QueryResult<
  TruckMenusQuery,
  TruckMenusQueryVariables
>
